import React from 'react'
import { formatDate } from '../../../utils/form-data';
import { cn } from '../../../utils/utils';
import loader from '../../../assets/logos/loader.svg'
import check from '../../../assets/logos/check.svg'
import reject from '../../../assets/logos/x-circle.svg'
import moment from 'moment-timezone'
 
const ItemDepositAndWithdraw = ({ item }) => {
  const getImageSrc = React.useMemo(() => {
    switch(item.status) {
      case 'pending': {
        return loader;
      }
      case 'approved': {
        return check;
      }

      default: {
        return reject
      }
    }
  }, [item.status])

  return (
    <div
      className={cn('flex gap-4 border-b-2 border-[#212325] justify-between items-center p-3 sm:p-8', {
        '': item.status === 'pending',
      })}
    >
      <p className="w-[33%] text-center">{moment.utc(item.createdAt).local().format('YYYY-MM-DD HH:mm:ss') || '-'}</p>
      <p className="w-[25%] text-center text-xl">{item.amount}</p>
      <p
        className={cn('w-[25%] text-center py-2 rounded-full relative border-2 bg-black', {
          'text-yellow-400 border-yellow-400':
            item.status === 'pending',
          'text-green-400 border-green-400': item.status === 'approved',
          'text-red-500 border-red-500': item.status === 'rejected'
        })}
      >
        {item.status.toUpperCase()}
      </p>
      <p className='w-[50px] hidden sm:inline-block'>
        <img src={getImageSrc} alt="" />
      </p>
    </div>
  );
};

export default ItemDepositAndWithdraw;
